// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__34eKU","label":"Radio_label__2yvll","checkMark":"Radio_checkMark__2FhI1","disabled":"Radio_disabled__1CF-o"};